<template>
	<v-card>
    <upload-concept-src-component
      :toggleLoading="toggleLoading"
      :isOpen="uploadConceptSrcDialog.dialog"
      :toggleUploadConceptSrcDialog="toggleUploadConceptSrcDialog"
      :showMessage="showMessage"
      :getData="getData"
    />
		<v-list>
			<v-subheader>Концепции</v-subheader>
			<v-list-item-group :value="currentConcept">
				<v-list-item
					v-for="concept in concepts"
					:key="concept"
					:value="concept"
				>
					<v-list-item-content>
						<v-list-item-title v-text="concept" align="left" @click="changePageConcept(concept)"></v-list-item-title>
					</v-list-item-content>
					<v-list-item-action style="display: block">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="success"
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                >
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="saveToExcel(concept)">
                  <v-icon left color="green">mdi-file-excel</v-icon>
                  Сохранить отчет в Excel
                </v-list-item>
                <v-list-item @click="downloadConceptSrc(concept)">
                  <v-icon left color="green">mdi-download</v-icon>
                  Экспорт
                </v-list-item>
                <v-list-item @click="shareConcept(concept)">
                  <v-icon left color="green">mdi-share-variant</v-icon>
                  Поделиться
                </v-list-item>
                <v-list-item @click="deleteConcept(concept)">
                  <v-icon left color="error">mdi-close-thick</v-icon>
                  <span class="pt-1">Удалить</span>
                </v-list-item>
              </v-list>
            </v-menu>
					</v-list-item-action>
				</v-list-item>
			</v-list-item-group>
		</v-list>
		<v-divider></v-divider>
		<v-card-actions class="justify-center">
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						text
						color="black"
						@click="saveDialog.dialog = true"
						:disabled="!isNotSaved"
						v-on="on"
					>
						<v-icon>mdi-content-save</v-icon>
					</v-btn>
				</template>
				<span>Сохранить</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						text
						color="success"
						@click="projectPage"
						v-on="on"
					>
						<v-icon style="margin-top: -8px">mdi-plus-thick</v-icon>
					</v-btn>
				</template>
				<span>Добавить новую концепцию</span>
			</v-tooltip>
      <v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						text
						color="success"
						@click="toggleUploadConceptSrcDialog"
						v-on="on"
					>
						<v-icon>mdi-upload</v-icon>
					</v-btn>
				</template>
				<span>Загрузить концепцию</span>
			</v-tooltip>
		</v-card-actions>
	</v-card>
</template>

<script>
  import UploadConceptSrcComponent from "@/components/Pages/ProjectPageComponents/UploadConceptSrcComponent";

  export default {
    name: "ListConceptComponent",
    props: {
      saveConcept: Function,
      concepts: Array,
      changePage: Function,
      saveDialog: Object,
      isNotSaved: Boolean,
      deleteConcept: Function,
      downloadConceptSrc: Function,
      toggleLoading: Function,
      uploadConceptSrcDialog: Object,
      toggleUploadConceptSrcDialog: Function,
      showMessage: Function,
      getData: Function,
      shareConcept: Function,
      saveToExcel: Function,
    },
    methods: {
      changePageConcept: function (concept) {
        this.changePage({
          name: 'ProjectPageConcept',
          params: {name: this.$route.params.name, concept: concept}
        })
      },
      projectPage: function () {
        this.changePage({
          name: 'ProjectPage',
          params: {name: this.$route.params.name}
        })
      }
    },
    computed: {
      currentConcept: function () {
        return this.$route.params.concept
      }
    },
    components: {
      UploadConceptSrcComponent,
    },
  }
</script>
